import { throttle } from 'lodash';
import { useCallback, useMemo } from 'react';

import { ActivityType, biHelpCenter } from '../../util/bi';

type UsePageEngagement = {
  onScroll: (event: React.UIEvent<HTMLDivElement>) => void;
  onMouseClick: (event: React.MouseEvent<HTMLDivElement>) => void;
  onMouseMove: (event: React.MouseEvent<HTMLDivElement>) => void;
  onScrollAddedContent: () => void;
};

export const usePageEngagement = (): UsePageEngagement => {
  const logScrollToBottom = useMemo(() => {
    return throttle(() => {
      biHelpCenter.logPageEngagementActivity(ActivityType.ScrollToBottom);
    }, 1000);
  }, []);

  const logScroll = useMemo(() => {
    return throttle(() => {
      biHelpCenter.logPageEngagementActivity(ActivityType.Scroll);
    }, 1000);
  }, []);

  const logMouseClick = useMemo(() => {
    return throttle(() => {
      biHelpCenter.logPageEngagementActivity(ActivityType.MouseClick);
    }, 1000);
  }, []);

  const logMouseMove = useMemo(() => {
    return throttle(() => {
      biHelpCenter.logPageEngagementActivity(ActivityType.MouseMove);
    }, 1000);
  }, []);

  const logScrollAddedContent = useMemo(() => {
    return throttle(() => {
      biHelpCenter.logPageEngagementActivity(ActivityType.ScrollAddedContent);
    }, 1000);
  }, []);

  const onScroll = useCallback(
    (e) => {
      const { scrollTop, scrollHeight, offsetHeight } = e.target;
      if (offsetHeight + scrollTop >= scrollHeight) {
        logScrollToBottom();
      } else {
        logScroll();
      }
    },
    [logScrollToBottom, logScroll],
  );

  return {
    onScroll,
    onMouseClick: logMouseClick,
    onMouseMove: logMouseMove,
    onScrollAddedContent: logScrollAddedContent,
  };
};
